import { PaginationConfig } from './pagination.config';

export const defaultPaginationConfig: PaginationConfig = {
  pagination: {
    addStart: true,
    addEnd: true,
  },
};
